import { mapGameName } from "../../constants/liveClass"
import FullSchedule from "./live-classes/full-schedule"
import Coaching from "./live-classes/coaching"
import LiveStream from "./live-classes/live-stream"
import moment from "moment"

import {
  getClassesByStatusAndOrder,
  fetchClasses,
  getAvailableGames,
  fetchLiveClassesByGameAndStatus,
} from "../../api/live-classes"
const state = {
  // Live classes page state
  liveClasses: [],
  upcomingClasses: [],
  recentClasses: [],
  pendingClasses: [],
  currentRecentClassesPage: 0,
  lastRecentClassesPage: 0,
  loading: true, // loading status for live-classes page
  // liveClass: null,
  games: [],
  selectedGames: [],
  // nextClass: null
}

const getters = {
  // Live Classes getters
  liveClasses: state => state.liveClasses,
  loading: state => state.loading,
  upcomingClasses: state => state.upcomingClasses,
  recentClasses: state => state.recentClasses,
  pendingClasses: state => state.pendingClasses,
  // liveClass: state => state.liveClass,
  recentClassGames: state => state.recentClassGames,
  currentRecentClassesPage: state => state.currentRecentClassesPage,
  lastRecentClassesPage: state => state.lastRecentClassesPage,
  games: state => state.games,
  selectedGames: state => state.selectedGames,
  // nextClass: state => state.nextClass
}

const mutations = {
  // Live Classes
  setLoading: (state, status) => (state.loading = status),
  setLiveClasses: (state, liveClasses) => (state.liveClasses = liveClasses),
  setUpcomingClasses: (state, upcomingClasses) =>
    (state.upcomingClasses = upcomingClasses),
  setRecentClasses: (state, recentClasses) =>
    (state.recentClasses = recentClasses),
  setPendingClasses: (state, pendingClasses) => (state.pendingClasses = pendingClasses),
  // setLiveClass: (state, liveClass) => (state.liveClass = liveClass),
  setTimeText: (state, text) => (state.timeText = text),
  setRecentClassGames: (state, recentClassGames) =>
    (state.recentClassGames = recentClassGames),
  setCurrentRecentClassesPage: (state, page) =>
    (state.currentRecentClassesPage = page),
  setLastRecentClassesPage: (state, page) =>
    (state.lastRecentClassesPage = page),
  setGames: (state, games) => (state.games = games),
  setSelectedGames: (state, games) => (state.selectedGames = games),
  // setNextClass: (state, nextClass) => (state.nextClass = nextClass)
}

const actions = {
  changeBackLoading ({ commit }) {
    commit("setLoading", true)
  },
  // async getLiveClasses({ commit }) {
  //   const liveClasses = await getClassesByStatusAndOrder(
  //     "LIVE",
  //     "NEWEST_FIRST"
  //   );
  //   for (let liveClass of liveClasses) {
  //     liveClass.game.name = mapGameName(liveClass.game.name);
  //   }
  //   commit("setLiveClasses", liveClasses);
  // },
  async getLiveClasses ({ commit }) {
    const res = await fetchLiveClassesByGameAndStatus()
    const games = res.result.data
    const liveClasses = []
    for (let game of games) {
      const pendingClasses = game.results.PENDING
      const length = pendingClasses.length
      for (let i = length - 1; i >= 0; i--) {
        const scheduledFor = moment.utc(pendingClasses[i].scheduled_for)
        const current = moment.utc()
        const diff = scheduledFor.diff(current, "minutes")
        if (diff < 10) {
          if (pendingClasses[i].game) {
            pendingClasses[i].game.name = mapGameName(pendingClasses[i].game.name)
          } else {
            pendingClasses[i].game = { name: mapGameName("") }
          }
          liveClasses.push(pendingClasses[i])
          break
        }
      }
    }
    commit("setLiveClasses", liveClasses)
  },
  async getUpcomingClasses ({ commit, state }) {
    const upcomingClasses = await getClassesByStatusAndOrder(
      "UPCOMING",
      "OLDEST_FIRST"
    )
    for (let upcomingClass of upcomingClasses) {
      if (upcomingClass.game) {
        upcomingClass.game.name = mapGameName(upcomingClass.game.name)
      } else {
        upcomingClass.game = { name: mapGameName("") }
      }
    }

    if (Array.isArray(upcomingClasses) && upcomingClasses.length > 0) {
      const nextClass = upcomingClasses[0]
      if (Array.isArray(state.liveClasses)) {
        if (state.liveClasses.length === 0) {
          await commit("setLiveClasses", [nextClass])
          commit("setUpcomingClasses", upcomingClasses.slice(1))
        } else {
          // remove live classes from upcoming classes
          // console.log(upcomingClasses)
          for (let i = 0; i < upcomingClasses.length; i++) {
            const scheduledFor = moment.utc(upcomingClasses[i].scheduled_for)
            const current = moment.utc()
            const diff = scheduledFor.diff(current, "minutes")
            if (diff < 10) {
              for (let liveClass of state.liveClasses) {
                if (upcomingClasses.length <= 0) {
                  break
                }
                if (upcomingClasses[i].id === liveClass.id) {
                  upcomingClasses.splice(i, 1)
                }
              }
            }
          }
          commit("setUpcomingClasses", upcomingClasses)
        }
      }
    }
  },
  async getPendingClasses ({ commit }, { games }) {
    const data = await fetchClasses({
      status: "PENDING",
      order: "OLDEST_FIRST",
      games: games,
    })
    const pendingClasses = data.result.data

    for (let pendingClass of pendingClasses) {
      if (pendingClass.game) {
        pendingClass.game.name = mapGameName(pendingClass.game.name)
      } else {
        pendingClass.game = { name: mapGameName("") }
      }
    }
    await commit("setPendingClasses", pendingClasses)
  },
  async getRecentClasses ({ commit }, { page, games }) {
    const data = await fetchClasses({
      status: "FINISHED",
      order: "NEWEST_FIRST",
      games: games || state.selectedGames,
      page,
    })
    const recentClasses = data.result.data.filter(
      recentClass => recentClass.live_stream.recordings.length > 0
    )
    for (let recentClass of recentClasses) {
      if (recentClass.game) {
        recentClass.game.name = mapGameName(recentClass.game.name)
      } else {
        recentClass.game = { name: mapGameName("") }
      }
    }
    // console.log(recentClasses);
    await commit("setRecentClasses", recentClasses)
    await commit("setCurrentRecentClassesPage", data.result.current_page)
    await commit("setLastRecentClassesPage", data.result.last_page)
  },
  async getRecentClassesNextPage ({ commit, state }, { page }) {
    const data = await fetchClasses({
      status: "FINISHED",
      order: "NEWEST_FIRST",
      games: state.selectedGames,
      page,
    })
    const recentClasses = data.result.data.filter(
      recentClass => recentClass.live_stream.recordings.length > 0
    )
    const newRecentClasses = state.recentClasses
    for (let recentClass of recentClasses) {
      if (recentClass.game) {
        recentClass.game.name = mapGameName(recentClass.game.name)
      } else {
        recentClass.game = { name: mapGameName("") }
      }
      newRecentClasses.push(recentClass)
    }
    await commit("setRecentClasses", newRecentClasses)
    await commit("setCurrentRecentClassesPage", data.result.current_page)
  },
  async getLiveClassesData ({ commit, dispatch }) {
    await dispatch("getLiveClasses")
    await dispatch("getUpcomingClasses")
    // await dispatch("getLiveClass");
    await dispatch("getRecentClasses", {})
    commit("setLoading", false)
  },
  // async getLiveClass({ commit, state }) {
  //   const { liveClasses, upcomingClasses } = state;
  //   if (Array.isArray(liveClasses) && liveClasses.length > 0) {
  //     await commit("setLiveClass", liveClasses[0]);
  //   } else if (Array.isArray(upcomingClasses) && upcomingClasses.length > 0) {
  //     const nextClass = upcomingClasses[0];
  //     await commit("setLiveClass", nextClass);
  //     await commit(
  //       "setUpcomingClasses",
  //       upcomingClasses.filter(
  //         upcomingClass => upcomingClass.id !== nextClass.id
  //       )
  //     );
  //   }
  // },

  async getAvailableGames ({ commit }) {
    const data = await getAvailableGames()

    const games = data.result.data
    commit("setGames", games)
  },
  async updateSelectedGames ({ commit, dispatch }, games) {
    await commit("setSelectedGames", games)
    dispatch("getRecentClasses", {
      status: "FINISHED",
      order: "NEWEST_FIRST",
      page: 1,
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  modules: {
    FullSchedule,
    Coaching,
    LiveStream,
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/live_classes.js